import Grid from "@mui/material/Grid/Grid";
import Box from "@mui/material/Box/Box";
import LOGO_WITH_LABEL_LARGE from "../../assets/images/logo-with-label-large.png";
import PHONE from "../../assets/images/phone.png";
import {CustomLabelXSmallBold, CustomLabelXSmallRegular, CustomLabelXXLargeBold} from "../common/CustomLabel";
import MAIL_BLACK from "../../assets/images/mail-black.png";
import MAP_PIN from "../../assets/images/map-pin.png";
import LINKED_IN from "../../assets/images/linked-in.png";
import FACEBOOK from "../../assets/images/facebook.png";
import INSTAGRAM from "../../assets/images/instagram.png";
import TWITTER from "../../assets/images/twitter.png";
import TIKTOK from "../../assets/images/tiktok.png";
import PINTEREST from "../../assets/images/pinterest.png";
import React from "react";
import {useLocation, useNavigate, Outlet} from "react-router-dom"
import Link from "@mui/material/Link/Link";
import { Link as RouterLink } from 'react-router-dom';
import YOUTUBE from "../../assets/icons/Youtube.png";
import LINKTREE from "../../assets/icons/Linktree.png";
import ARROW_UP from "../../assets/images/arrow-up-right.png";


const Footer=({setShowOnDemandDevelopers})=>{

    const arrow = () => {
        return (
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.00004 16.3333L15.8334 5.49996M15.8334 5.49996V15.9M15.8334 5.49996H5.43337" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        )
    }

    let navigate = useNavigate();

    const onClickUI=(e)=>{
        navigate(`/our-work?details=UI/UX`)
    }


    const onClickSaas=(e)=>{
        navigate(`/our-work?details=SaaS`)
    }

    const onClickMobileAppDevelopment=(e)=>{
        navigate(`/our-work?details=Mobile App Development`)
    }


    const onClickWebAppDevelopment=(e)=>{
        navigate(`/our-work?details=Web App Development`)
    }


    const onClickGraphicsDesign=(e)=>{
        navigate(`/our-work?details=Graphic Design`)
    }


    const onClickVideoEditing=(e)=>{
        navigate(`/our-work?details=Video Editing`)
    }

    const onClickViewAll=(e)=>{
        navigate(`/our-work`)
    }



    const onClickBlogs=(e)=>{
        navigate(`/blogs`)
    }


    const onClickCaseStudies=(e)=>{
        navigate(`/blogs?details=case studies`)
    }


    const onClickCertifications=(e)=>{
        navigate(`/certifications`)
    }


    const onClickTermsConditions=(e)=>{
        navigate(`/terms-condition`)
    }


    const onClickRefundPolicy=(e)=>{
        navigate(`/refund-policy`)
    }


    const onClickContactUs=(e)=>{
        navigate(`/contact-us`)
    }


    const onClickAboutUs=(e)=>{
        navigate(`/about-us`)
    }

    return(
        <Grid container sx={{marginTop: "0px", background: "#FAF7FF", py: {xs: "30px", md: "40px"}, px :{ xs: 1, md: 10}}}
              justifyContent={"space-between"}>
            <Grid item xs={12} md={4}>

                <Grid container>
                    <Grid item>
                        <Box component={"img"} src={LOGO_WITH_LABEL_LARGE} alt={"OSTRYX"} sx={{width: "100%"}}/>
                    </Grid>
                    <Grid item container sx={{marginTop: {xs: "5px", md: "10px"}}} alignItems={"center"}>
                        <Grid item style={{marginTop: "2px"}}>
                            <img src={MAIL_BLACK} alt={"Mail Black"}/>
                        </Grid>
                        <Grid item style={{marginLeft: "10px", marginBottom: "2px"}}>
                            <CustomLabelXSmallRegular text={"info@ostryx.com"}/>
                        </Grid>
                    </Grid>
                    {/* <Grid item container sx={{marginTop: {xs: "5px", md: "10px"}}} alignItems={"center"}>
                        <Grid item style={{marginTop: "2px"}}>
                            <img src={PHONE}/>
                        </Grid>
                        <Grid item sx={{marginLeft: "10px", marginBottom: "2px"}}>
                            <CustomLabelXSmallRegular text={"+971 50 2452251"}/>
                        </Grid>
                    </Grid>
                    <Grid item container sx={{marginTop: {xs: "5px", md: "10px"}}}alignItems={"center"}>
                        <Grid item>
                            <img src={MAP_PIN}/>
                        </Grid>
                        <Grid item xs style={{marginLeft: "10px"}}>
                            <CustomLabelXSmallRegular normal={true}
                                                      text={"MAG 218, Sheikh Mohammed bin Rashid Boulevard, Dubai Marina, UAE"}/>
                        </Grid>
                    </Grid> */}
                    <Grid item container sx={{marginTop: {xs: "5px", md: "10px"}}} alignItems={"center"}>
                        <Grid item style={{marginTop: "2px"}}>
                            <img src={PHONE} alt={"Phone"}/>
                        </Grid>
                        <Grid item sx={{marginLeft: "10px", marginBottom: "2px"}}>
                            <CustomLabelXSmallRegular text={"+1 (850) 586-1700"}/>
                        </Grid>
                    </Grid>
                    <Grid item container sx={{marginTop: {xs: "5px", md: "10px"}}} alignItems={"center"}>
                        <Grid item>
                            <img src={MAP_PIN} alt={"Map Pin"}/>
                        </Grid>
                        <Grid item xs style={{marginLeft: "10px"}}>
                            <CustomLabelXSmallRegular normal={true}
                                                      text={"4628 Southwinds Drive Destin, FL 32550 United States"}/>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>


            <Grid 
                container 
                item 
                xs={12} 
                md={6.5} 
                sx={{
                    marginTop: {xs: "30px", md: "0px"},
                }}
            >
                {/* Services & Solutions Section - Left Column */}
                <Grid item xs={6} sm={4} md={3.5}>
                    <Grid container direction="column">
                        <Grid item>
                            <CustomLabelXSmallBold text="SERVICES & SOLUTIONS" color="#5E17EB"/>
                        </Grid>
                        <Grid item container direction="column">
                            {/* <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/brand-kit-detail" className="plain-link">
                                        BrandKit Design
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/ui-ux-design" className="plain-link">
                                        UI/UX Design
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid> */}
                            {/* <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/saas-detail" className="plain-link">
                                        SaaS
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid> */}
                            {/* <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/frontend-dev-detail" className="plain-link">
                                        Frontend Development
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/backend-dev-detail" className="plain-link">
                                        Backend Development
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/full-stack-detail" className="plain-link">
                                        Full-stack Development
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid> */}
                            {/* <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/on-demand-developers" className="plain-link">
                                    On-Demand Developers
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/full-project-development" className="plain-link">
                                    Full Project Development
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/project-by-equity" className="plain-link">
                                    Project By Equity
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid> */}
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/web-app-development" className="plain-link">
                                        Web App Development
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/mobile-app-development" className="plain-link">
                                        Mobile App Development
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            {/* <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/quality-assurance-detail" className="plain-link">
                                        Quality Assurance
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/devops-cloud-services-detail" className="plain-link">
                                        Devops and Cloud Services
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid> */}
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/ai-mechine-learning" className="plain-link">
                                        AI & Machine Learning
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/ui-ux-design" className="plain-link">
                                        UI/UX Design
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/devops-cloud" className="plain-link">
                                        DevOps & Cloud
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/custom-software-development" className="plain-link">
                                        Custom Software Development
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            {/* <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/graphic-design-detail" className="plain-link">
                                        Graphic Design
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/vedio-edit-detail" className="plain-link">
                                        Video Editing
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid> */}
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link 
                                    component={RouterLink} 
                                    to="/services" 
                                    className="plain-link" 
                                    sx={{ 
                                        textDecoration: 'underline !important',
                                        display: 'inline-flex', 
                                        alignItems: 'center' 
                                    }}
                                    >
                                    Learn More
                                    <Box component="span" sx={{ marginLeft: '5px' }}>
                                        {arrow()}
                                    </Box>
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>

                {/* Policies Section - Left Column */}
                <Grid item xs={6} sm={4} md={3.5}>
                    <Grid container direction="column">
                        <Grid item>
                            <CustomLabelXSmallBold text="RESOURCES & POLICIES" color="#5E17EB"/>
                        </Grid>
                        <Grid item container direction="column">
                            {/* <Grid item sx={{ cursor: "pointer" }}>
                                <CustomLabelXSmallRegular>
                                    <Link component={RouterLink} to="/blogs?details=case studies" className="plain-link">
                                        Case Studies
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid> */}
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/terms-condition" className="plain-link">
                                        Terms & Conditions
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                            <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/privacy-policy" className="plain-link">
                                        Privacy Policy
                                    </Link>
                                </CustomLabelXSmallRegular>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {/* Info Section - Right Column */}
                <Grid item xs={6} sm={4} md={3.5}>
                    <Grid container direction="column" sx={{marginTop: {xs: "20px", md: "0px"}}}>
                        <Grid item>
                            <CustomLabelXSmallBold text="INFO" color="#5E17EB"/>
                        </Grid>
                        <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/about-us" className="plain-link">
                                        About Us
                                    </Link>
                                </CustomLabelXSmallRegular>
                        </Grid>
                        <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                    <Link component={RouterLink} to="/blogs" className="plain-link">
                                        Blogs
                                    </Link>
                                </CustomLabelXSmallRegular>
                        </Grid>
                        <Grid item sx={{ mt: "10px", cursor: "pointer" }}>
                                <CustomLabelXSmallRegular normal={true}>
                                <Link 
                                        component={RouterLink} 
                                        to="/contact-us" 
                                        className="plain-link"
                                        onClick={onClickContactUs}
                                    >
                                        Help & Contact
                                    </Link>
                                </CustomLabelXSmallRegular>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item container xs={12} justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "40px"}}}>
                <CustomLabelXXLargeBold text={"Let's Build Together!"} component={"h1"} style={{fontSize: "9vw"}} color={"#E8DCFF"}
                                        textAlign={"center"}/>
            </Grid>


            <Grid item container justifyContent={{xs: 'space-between', md: "space-between"}}
                  sx={{marginTop: {xs: "30px", md: "40px"}}} alignItems={"center"}>

                <Grid item>
                    <CustomLabelXSmallRegular text={"© All rights reserved 2025 | Built with ❤ & 💡 "}
                                              color={"#8D8D8D"}/>
                </Grid>

                <Grid container sx={{display: {xs: "none", md: "none"}}}></Grid>
                <Grid item sx={{marginTop: {xs: "0px", md: "0px"}}}>

                    <Grid container spacing={1}>
                        <Grid item>
                            <Link href="https://www.linkedin.com/company/ostryx/" target="_blank" rel="noopener noreferrer">
                                <img src={LINKED_IN} alt={"LinkedIn"} style={{ cursor: 'pointer' }}/>
                            </Link>
                        </Grid>
                        {/* <Grid item>
                            <img src={FACEBOOK}/>
                        </Grid> */}
                        <Grid item>
                            <Link href="https://www.instagram.com/ostryxsolutions/" target="_blank" rel="noopener noreferrer">
                                <img src={INSTAGRAM} alt={"Instagram"} style={{ cursor: 'pointer' }}/>
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link href="https://linktr.ee/ostryx" target="_blank" rel="noopener noreferrer">
                                <img src={LINKTREE} alt={"Linktree"} style={{width: "20px", height: "20px"}}/>
                            </Link>
                        </Grid>
                        {/* <Grid item>
                            <Link href="https://www.tiktok.com/@ostryxpvtltd" target="_blank" rel="noopener noreferrer">
                                <img src={TIKTOK} alt={"TikTok"} style={{ cursor: 'pointer' }}/>
                            </Link>
                        </Grid> */}
                        {/* <Grid item>
                            <Link href="https://www.youtube.com/@OstryxSolutions" target="_blank" rel="noopener noreferrer">
                                <img src={YOUTUBE} alt={"Youtube"} style={{width: "20px", height: "20px"}}/>
                            </Link>
                        </Grid> */}
                    </Grid>

                </Grid>

            </Grid>


        </Grid>
    )
}


export default Footer;
